import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { fileUrl } from "@/lib/api";

export default function Navbar({ siteInfo }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#about", label: "Betrieb" },
    { href: "#services", label: "Leistungen" },
    { href: "#gallery", label: "Galerie" },
    { href: "#vorher-nachher", label: "Vorher / Nachher" },
    { href: "#reviews", label: "Bewertungen" },
    { href: "#contact", label: "Kontakt" },
  ];

  const hasLogo = !!siteInfo?.logo_path;

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled ? "bg-sand-100/85 backdrop-blur-xl border-b border-sand-300" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo" className="flex items-center gap-3">
          {hasLogo ? (
            <img
              src={fileUrl(siteInfo.logo_path)}
              alt={`${siteInfo?.company_name || "Logo"}`}
              className="h-12 w-auto object-contain"
            />
          ) : (
            <span className="flex flex-col leading-none">
              <span className="text-[10px] uppercase tracking-[0.25em] text-sage font-bold">Malermeister</span>
              <span className="font-display text-2xl text-stone-900">{siteInfo?.company_name?.replace(/^Malermeister\s*/i, "") || "Santo Russo"}</span>
            </span>
          )}
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm text-stone-700 hover:text-clay transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-contact"
            className="ml-2 px-6 py-2.5 bg-stone-900 text-sand-100 text-sm hover:bg-clay transition-colors duration-300 rounded-sm"
          >
            Termin anfragen
          </a>
        </nav>

        <button
          data-testid="navbar-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-stone-900"
          aria-label="Menü öffnen"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-sand-100 border-t border-sand-300" data-testid="mobile-menu">
          <nav className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.href.slice(1)}`}
                className="text-stone-900 hover:text-clay transition-colors py-1"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
